/** "Which version am I running?" — shown at the bottom of Settings: the app around the page and the page itself. */
import { desktop } from './desktop.ts';
import { isNative, nativePlatform } from './native.ts';

declare const __WEB_COMMIT__: string;
/** The server code this page was built from (the commit `infra/deploy.sh` put live). */
export const webCommit: string = typeof __WEB_COMMIT__ === 'string' ? __WEB_COMMIT__ : 'dev';

/** iPhone/Android: "0.1.4 (29912345)"; Mac/Windows app: "0.1.4"; browser: null. */
export async function appVersion(): Promise<string | null> {
  if (desktop) return /\s[^\s/]+\/(\d+\.\d+\.\d+)\s+Chrome\//.exec(navigator.userAgent)?.[1] ?? null;
  if (isNative && (nativePlatform === 'ios' || nativePlatform === 'android')) {
    try {
      const { App } = await import('@capacitor/app');
      const info = await App.getInfo();
      return `${info.version} (${info.build})`;
    } catch {
      return null;
    }
  }
  return null;
}
